var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "panel", attrs: { id: "panel-4" } },
    [
      _c("div", { staticClass: "panel-hdr" }, [
        _c("h2", [
          _vm._v("\n            " + _vm._s(_vm.__t("LIST")) + " "),
          _c("span", { staticClass: "fw-300" }, [
            _c("i", [_vm._v(_vm._s(_vm.__t("ROLES")))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panel-toolbar" },
          [
            _c("b-overlay", { attrs: { show: _vm.is_load } }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed",
                  on: { click: _vm.create },
                },
                [_c("i", { staticClass: "fal fa-plus" })]
              ),
            ]),
            _vm._v(" "),
            _c("button", {
              staticClass: "btn btn-panel waves-effect waves-themed",
              attrs: {
                "data-action": "panel-fullscreen",
                "data-toggle": "tooltip",
                "data-offset": "0,10",
                "data-original-title": "Fullscreen",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "panel-container show" }, [
        _c(
          "div",
          { staticClass: "panel-content" },
          [
            _c(
              "b-row",
              _vm._l(_vm.rows, function (item) {
                return _c(
                  "b-col",
                  {
                    key: "role_" + item.id,
                    attrs: { cols: 12, md: 4, lg: 4, xl: 4 },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "role-card card shadow-xs mb-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-header d-flex align-items-center",
                          },
                          [
                            _c("div", { staticClass: "role-avatar mr-3" }, [
                              !_vm.is_tg(item)
                                ? _c(
                                    "span",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base-2 icon-stack-3x color-primary-400",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "base-10 text-white icon-stack-1x",
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "ni md-profile color-primary-800 icon-stack-2x",
                                      }),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "icon-stack fs-xxl" },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "base-2 icon-stack-3x color-info-400",
                                      }),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex-fill" }, [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "role-title text-truncate" },
                                    [_vm._v(_vm._s(item.title))]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "ml-auto d-flex align-items-center",
                              },
                              [
                                !_vm.is_tg(item)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-switch mr-2",
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: "role-switch-" + item.id,
                                            type: "checkbox",
                                          },
                                          domProps: { checked: item.published },
                                          on: {
                                            change: function ($event) {
                                              return _vm.toggleActive(item)
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: {
                                            for: "role-switch-" + item.id,
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      right: "",
                                      size: "sm",
                                      variant: "light",
                                      "no-caret": "",
                                      "toggle-class":
                                        "btn-icon btn-light border-0",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("i", {
                                                staticClass:
                                                  "fal fa-ellipsis-v",
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.edit(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fal fa-pen mr-2",
                                        }),
                                        _vm._v(
                                          _vm._s(_vm.__t("EDIT")) +
                                            "\n                                    "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("b-dropdown-divider"),
                                    _vm._v(" "),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        staticClass: "text-danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.remove(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fal fa-trash-alt mr-2",
                                        }),
                                        _vm._v(_vm._s(_vm.__t("REMOVE"))),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-muted small mb-2 font-weight-600",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.__t("LOCAIONS_COUNT")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "zones-wrap mb-3" }, [
                            item.locations_ids.length
                              ? _c("span", { staticClass: "badge zone-pill" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(item.locations_ids.length) +
                                      "\n                              "
                                  ),
                                ])
                              : _c(
                                  "span",
                                  { staticClass: "text-muted small" },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.__t("ALL")) +
                                        "\n                                "
                                    ),
                                  ]
                                ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-muted small mb-2 font-weight-600",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.__t("PIN")) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "code-row d-flex align-items-center",
                            },
                            [
                              _c("div", { staticClass: "code-box flex-fill" }, [
                                _vm._v(_vm._s(item.pin || "—")),
                              ]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.show_copy(item)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "card-footer d-flex justify-content-between",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-sm btn-warning d-flex align-items-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyCode(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fal fa-copy mr-2",
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.__t("COPY_CODE")) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.show_open_url(item)
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-success d-flex align-items-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.open(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fal fa-copy mr-2",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.__t("OPEN_URL")) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("role_modal", { on: { remove: _vm.remove } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }